/**
 * @file menuData.js
 * @description Datos del menú de DeliRous Restaurant extraídos de la carta oficial, con traducciones al inglés.
 */

export const menuData = [
  {
    id: "ensaladas",
    label: "Ensaladas",
    label_en: "Salads",
    icon: "🥗",
    items: [
      {
        name: "Ensalada Campestre",
        name_en: "Country Salad",
        price: 24,
        description: "Pechuga de pollo en cubos, acompañada de choclo, palta y lechuga",
        description_en: "Diced chicken breast, accompanied by Peruvian corn, avocado, and lettuce",
      },
      {
        name: "Ensalada Mixta",
        name_en: "Mixed Salad",
        price: 28,
        description: "Trozos de filete pollo, champiñones, queso, choclo, palta, lechuga, tomate y pimiento",
        description_en: "Pieces of chicken fillet, mushrooms, cheese, Peruvian corn, avocado, lettuce, tomato, and bell pepper",
      },
    ],
  },
  {
    id: "aperitivos-criollos",
    label: "Aperitivos Criollos",
    label_en: "Creole Appetizers",
    icon: "🫔",
    items: [
      {
        name: "Causa Clásica",
        name_en: "Classic Causa",
        price: 24,
        description: "Rellena de pollo y verduras cocidas",
        description_en: "Filled with chicken and cooked vegetables",
      },
      {
        name: "Tequeños",
        name_en: "Tequeños",
        price: 20,
        description: "Rellenos de queso (12 unidades)",
        description_en: "Cheese-filled (12 pieces)",
      },
      {
        name: "Tequeños de Lomo",
        name_en: "Lomo Tequeños",
        price: 28,
        description: "12 unidades",
        description_en: "12 pieces",
      },
    ],
  },
  {
    id: "chupes-sopas",
    label: "Chupes & Sopas",
    label_en: "Chowders & Soups",
    icon: "🍲",
    items: [
      {
        name: "Sopa de Dieta",
        name_en: "Diet Soup",
        price: 19,
        description: "Con trozos de pechuga de pollo, papa amarilla y cabello de ángel",
        description_en: "With pieces of chicken breast, yellow potato, and angel hair pasta",
      },
      {
        name: "Sopa a la Minuta",
        name_en: "Minuta Soup",
        price: 25,
        description: "Con carne picada (res o pollo), papa amarilla, leche y fideos",
        description_en: "With minced meat (beef or chicken), yellow potato, milk, and noodles",
      },
      {
        name: "Chupe de Pescado",
        name_en: "Fish Chowder",
        price: 32,
        description: "",
        description_en: "",
      },
    ],
  },
  {
    id: "ceviches-tiraditos",
    label: "Ceviches & Tiraditos",
    label_en: "Ceviches & Tiraditos",
    icon: "🐟",
    items: [
      {
        name: "Ceviche de Pesca del Día",
        name_en: "Catch of the Day Ceviche",
        price: 32,
        description: "Elaborado con pescado fresco del día, acompañado de camote y choclo",
        description_en: "Made with fresh catch of the day, accompanied by sweet potato and Peruvian corn",
      },
      {
        name: "Ceviche Mixto",
        name_en: "Mixed Ceviche",
        price: 35,
        description: "Elaborado con pescado fresco del día, calamar, pulpo y conchas de abanico. Acompañado de camote y choclo",
        description_en: "Made with fresh catch of the day, squid, octopus, and scallops. Accompanied by sweet potato and Peruvian corn",
      },
      {
        name: "Ceviche Carretillero",
        name_en: "Carretillero Ceviche",
        price: 38,
        description: "Elaborado con pescado fresco del día en crema de rocoto. Acompañado de camote, choclo y chicharrón de pota",
        description_en: "Made with fresh catch of the day in rocoto cream. Accompanied by sweet potato, Peruvian corn, and crispy giant squid",
      },
    ],
  },
  {
    id: "aperitivos-marinos",
    label: "Aperitivos Marinos",
    label_en: "Seafood Appetizers",
    icon: "🦐",
    items: [
      {
        name: "Leche de Tigre Clásica",
        name_en: "Classic Leche de Tigre",
        price: 17,
        description: "Trozos de pescado acompañados de choclo, ají, chifle y canchita",
        description_en: "Fish chunks accompanied by Peruvian corn, chili, plantain chips, and toasted corn",
      },
      {
        name: "Causa de Langostinos",
        name_en: "Prawn Causa",
        price: 26,
        description: "Causa rellena de langostinos, palta, coronada con langostinos al panko",
        description_en: "Causa filled with prawns and avocado, topped with panko breaded prawns",
      },
      {
        name: "Causa de Pulpa de Cangrejo",
        name_en: "Crab Meat Causa",
        price: 26,
        description: "Causa rellena de pulpa de cangrejo y palta, coronada con pulpa de cangrejo al panko",
        description_en: "Causa filled with crab meat and avocado, topped with panko breaded crab meat",
      },
      {
        name: "Causa Acevichada",
        name_en: "Acevichada Causa",
        price: 38,
        description: "Causa a elección acompañada de ceviche de pescado",
        description_en: "Causa of your choice accompanied by fish ceviche",
      },
    ],
  },
  {
    id: "jaleas",
    label: "Jaleas",
    label_en: "Jaleas (Crispy Seafood)",
    icon: "🍤",
    items: [
      {
        name: "Chicharrón de Pota",
        name_en: "Crispy Giant Squid",
        price: 28,
        description: "Acompañado de yucas fritas y shot de leche de tigre",
        description_en: "Accompanied by fried yuca and a shot of leche de tigre",
      },
      {
        name: "Chicharrón de Pescado",
        name_en: "Crispy Fish",
        price: 35,
        description: "Acompañado de yucas fritas y shot de leche de tigre",
        description_en: "Accompanied by fried yuca and a shot of leche de tigre",
      },
      {
        name: "Chicharrón Mixto",
        name_en: "Mixed Crispy Seafood",
        price: 38,
        description: "Elaborado con pescado y mariscos. Acompañado de yucas fritas y shot de leche de tigre",
        description_en: "Made with fish and seafood. Accompanied by fried yuca and a shot of leche de tigre",
      },
      {
        name: "Jalea Real",
        name_en: "Royal Jalea",
        price: 42,
        description: "Filete de pescado, mariscos, yucas fritas y shot de leche de tigre",
        description_en: "Fish fillet, seafood, fried yuca, and a shot of leche de tigre",
      },
    ],
  },
  {
    id: "arroces",
    label: "Arroces",
    label_en: "Rice Dishes",
    icon: "🍚",
    items: [
      {
        name: "Arroz Chaufa de Pollo",
        name_en: "Chicken Fried Rice",
        price: 26,
        description: "Acompañado de salsa de tamarindo y chips de wantán",
        description_en: "Accompanied by tamarind sauce and wonton chips",
      },
      {
        name: "Arroz Chaufa de Cecina",
        name_en: "Cecina Fried Rice",
        price: 28,
        description: "Acompañado de plátano frito y ají de cocona",
        description_en: "Accompanied by fried plantain and cocona chili sauce",
      },
      {
        name: "Arroz Chaufa de Carne",
        name_en: "Beef Fried Rice",
        price: 30,
        description: "",
        description_en: "",
      },
      {
        name: "Arroz Chaufa de Pescado",
        name_en: "Fish Fried Rice",
        price: 32,
        description: "",
        description_en: "",
      },
      {
        name: "Arroz con Mariscos",
        name_en: "Seafood Rice",
        price: 34,
        description: "",
        description_en: "",
      },
      {
        name: "Arroz Chaufa de Mariscos",
        name_en: "Seafood Fried Rice",
        price: 34,
        description: "",
        description_en: "",
      },
    ],
  },
  {
    id: "pastas",
    label: "Pastas",
    label_en: "Pastas",
    icon: "🍝",
    items: [
      {
        name: "Tallarín Saltado de Pollo",
        name_en: "Chicken Sautéed Noodles",
        price: 26,
        description: "Con fideos artesanales",
        description_en: "With artisanal noodles",
      },
      {
        name: "Tallarín Saltado de Carne",
        name_en: "Beef Sautéed Noodles",
        price: 30,
        description: "Con fideos artesanales",
        description_en: "With artisanal noodles",
      },
    ],
  },
  {
    id: "pollo",
    label: "Pollo",
    label_en: "Chicken",
    icon: "🍗",
    items: [
      {
        name: "Pollada",
        name_en: "Pollada",
        price: 31,
        description: "1/4 de pollo frito acompañado de papas sancochadas, arroz y ensalada",
        description_en: "1/4 fried chicken accompanied by boiled potatoes, rice, and salad",
      },
      {
        name: "Filete de Pollo a la Plancha",
        name_en: "Grilled Chicken Fillet",
        price: 22,
        description: "Acompañado de papas sancochadas, arroz y ensalada",
        description_en: "Accompanied by boiled potatoes, rice, and salad",
      },
      {
        name: "Filete de Pollo con Papas Fritas",
        name_en: "Chicken Fillet with French Fries",
        price: 27,
        description: "",
        description_en: "",
      },
      {
        name: "Pollo Saltado",
        name_en: "Sautéed Chicken",
        price: 28,
        description: "",
        description_en: "",
      },
      {
        name: "Filete de Pollo en Salsa de Champiñones",
        name_en: "Chicken Fillet in Mushroom Sauce",
        price: 30,
        description: "Acompañado de papas sancochadas y arroz",
        description_en: "Accompanied by boiled potatoes and rice",
      },
      {
        name: "Filete de Pollo a lo Pobre",
        name_en: "Poor Man's Chicken Fillet",
        price: 28,
        description: "Acompañado de arroz, plátano, huevo frito y papas fritas",
        description_en: "Accompanied by rice, plantain, fried egg, and french fries",
      },
      {
        name: "Milanesa de la Casa con Papas Fritas",
        name_en: "House Milanese with French Fries",
        price: 30,
        description: "Acompañada de una porción de arroz y ensalada",
        description_en: "Accompanied by a portion of rice and salad",
      },
    ],
  },
  {
    id: "bistecs-lomos",
    label: "Bistécs & Lomos",
    label_en: "Steaks & Lomo",
    icon: "🥩",
    items: [
      {
        name: "Bistéc con Papas Fritas",
        name_en: "Steak with French Fries",
        price: 30,
        description: "",
        description_en: "",
      },
      {
        name: "Bistec a lo Pobre",
        name_en: "Poor Man's Steak",
        price: 34,
        description: "Bistec acompañado de plátano frito, huevo frito y arroz graneado",
        description_en: "Steak accompanied by fried plantain, fried egg, and grained rice",
      },
      {
        name: "Bistec Apanado",
        name_en: "Breaded Steak",
        price: 34,
        description: "Acompañado de papas fritas, arroz y ensalada",
        description_en: "Accompanied by french fries, rice, and salad",
      },
      {
        name: "Lomo Saltado",
        name_en: "Lomo Saltado",
        price: 34,
        description: "Acompañado de papas fritas y arroz",
        description_en: "Accompanied by french fries and rice",
      },
      {
        name: "Tacu Tacu con Lomo Saltado",
        name_en: "Tacu Tacu with Lomo Saltado",
        price: 34,
        description: "",
        description_en: "",
      },
      {
        name: "Tacu Tacu a lo Pobre",
        name_en: "Poor Man's Tacu Tacu",
        price: 36,
        description: "Con bistec montado acompañado de plátano y huevo frito",
        description_en: "With mounted steak accompanied by plantain and fried egg",
      },
    ],
  },
  {
    id: "filete-pescado",
    label: "Filete de Pescado",
    label_en: "Fish Fillet",
    icon: "🐠",
    items: [
      {
        name: "Filete de Pescado a la Plancha",
        name_en: "Grilled Fish Fillet",
        price: 30,
        description: "Acompañado de yucas fritas y papas doradas",
        description_en: "Accompanied by fried yuca and golden potatoes",
      },
      {
        name: "Filete de Pescado en Salsa de Champiñones",
        name_en: "Fish Fillet in Mushroom Sauce",
        price: 35,
        description: "Acompañado de papas y arroz",
        description_en: "Accompanied by potatoes and rice",
      },
    ],
  },
  {
    id: "sudados-parihuelas",
    label: "Sudados & Parihuelas",
    label_en: "Sudados & Parihuelas",
    icon: "🥘",
    items: [
      {
        name: "Sudado de Filete de Pescado",
        name_en: "Fish Fillet Sudado",
        price: 32,
        description: "Acompañado de porción de arroz y yuca dorada",
        description_en: "Accompanied by a portion of rice and golden yuca",
      },
      {
        name: "Parihuela de Pescado",
        name_en: "Fish Parihuela",
        price: 42,
        description: "Acompañado de porción de arroz y yuca dorada",
        description_en: "Accompanied by a portion of rice and golden yuca",
      },
    ],
  },
  {
    id: "vegetarianos",
    label: "Los Vegetarianos",
    label_en: "Vegetarians",
    icon: "🥦",
    items: [
      {
        name: "Arroz a la Cubana",
        name_en: "Cuban Rice",
        price: 18,
        description: "Arroz blanco acompañado de plátano frito y huevos fritos",
        description_en: "White rice accompanied by fried plantain and fried eggs",
      },
      {
        name: "Tortilla de Verduras",
        name_en: "Vegetable Omelet",
        price: 22,
        description: "Acompañado de una porción de arroz",
        description_en: "Accompanied by a portion of rice",
      },
    ],
  },
  {
    id: "duos",
    label: "Dúos",
    label_en: "Duos",
    icon: "🍽️",
    items: [
      {
        name: "Arroz Chaufa de Mariscos + Ceviche de Pescado",
        name_en: "Seafood Fried Rice + Fish Ceviche",
        price: 32,
        description: "",
        description_en: "",
      },
      {
        name: "Arroz Chaufa de Pescado + Ceviche de Pescado",
        name_en: "Fish Fried Rice + Fish Ceviche",
        price: 32,
        description: "",
        description_en: "",
      },
      {
        name: "Arroz con Mariscos + Ceviche de Pescado",
        name_en: "Seafood Rice + Fish Ceviche",
        price: 32,
        description: "",
        description_en: "",
      },
      {
        name: "Chicharrón de Pescado + Ceviche de Pescado",
        name_en: "Crispy Fish + Fish Ceviche",
        price: 34,
        description: "",
        description_en: "",
      },
      {
        name: "Dúo a Elección",
        name_en: "Duo of Your Choice",
        price: 38,
        description: "",
        description_en: "",
      },
    ],
  },
  {
    id: "trios",
    label: "Tríos",
    label_en: "Trios",
    icon: "🥡",
    items: [
      {
        name: "Arroz con Mariscos + Ceviche de Pescado + Chicharrón de Pescado",
        name_en: "Seafood Rice + Fish Ceviche + Crispy Fish",
        price: 39,
        description: "",
        description_en: "",
      },
      {
        name: "Arroz Chaufa de Mariscos + Ceviche de Pescado + Chicharrón de Pescado",
        name_en: "Seafood Fried Rice + Fish Ceviche + Crispy Fish",
        price: 39,
        description: "",
        description_en: "",
      },
      {
        name: "Arroz con Mariscos + Ceviche + Causa",
        name_en: "Seafood Rice + Ceviche + Causa",
        price: 40,
        description: "",
        description_en: "",
      },
      {
        name: "Trío a Elección",
        name_en: "Trio of Your Choice",
        price: 42,
        description: "",
        description_en: "",
      },
    ],
  },
  {
    id: "fuentes-compartir",
    label: "Fuentes para Compartir",
    label_en: "Platters to Share",
    icon: "🫕",
    items: [
      {
        name: "Ceviche de Pescado",
        name_en: "Fish Ceviche",
        price: 90,
        description: "600gr de pescado",
        description_en: "600gr of fish",
      },
      {
        name: "Chicharrón de Pescado",
        name_en: "Crispy Fish",
        price: 90,
        description: "Acompañado de yucas fritas y leche de tigre",
        description_en: "Accompanied by fried yuca and leche de tigre",
      },
      {
        name: "Arroz con Mariscos",
        name_en: "Seafood Rice",
        price: 90,
        description: "Acompañado de salsa criolla",
        description_en: "Accompanied by salsa criolla",
      },
    ],
  },
  {
    id: "guarniciones",
    label: "Guarniciones",
    label_en: "Side Dishes",
    icon: "🍟",
    items: [
      { name: "Arroz Blanco", name_en: "White Rice", price: 6, description: "", description_en: "" },
      { name: "Camote", name_en: "Sweet Potato", price: 3, description: "", description_en: "" },
      { name: "Papas Fritas", name_en: "French Fries", price: 7, description: "", description_en: "" },
      { name: "Plátano Frito", name_en: "Fried Plantain", price: 6, description: "", description_en: "" },
      { name: "Porción de Palta", name_en: "Avocado Portion", price: 5, description: "", description_en: "" },
      { name: "Huevo Frito", name_en: "Fried Egg", price: 2, description: "Frito | A la inglesa", description_en: "Fried | Sunny-side up" },
      { name: "Yuca Frita", name_en: "Fried Yuca", price: 7, description: "", description_en: "" },
    ],
  },
];
